require("./chooseartist.dialog");
require("./ground.dialog");
require("./newappointment.dialog");